import * as React from 'react';
import { connect } from 'react-redux';
import {
  SettingTabPanelListRow,
  SettingTabPanelListRowImageTitle,
} from '../../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../../common/ToolIconRadioButtonSet';
import ObjectDrawingUIAction from '../../../actions/ui/ObjectDrawingUIAction';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../../reducers/app';
import { LineWidth } from '../../../types/lineWidth';
import SelectableNormalIconButton
from '../../common/SelectableIconButton/SelectableNormalIconButton';

interface ObjectLineWidthTabPanelListRowProps {
  selected: number;
  lineWidth: number;
  dispatch: Dispatch<Action>;
}

const titleContainerStyle: React.CSSProperties = {
  width: '105px',
};

const titleStyle: React.CSSProperties = {
  width: '92px',
};

const ObjectLineWidthTabPanelListRow: React.SFC<
  ObjectLineWidthTabPanelListRowProps
> = React.memo((props) => {
  const { selected, lineWidth, dispatch } = props;

  return (
    <SettingTabPanelListRow>
      <SettingTabPanelListRowImageTitle
        imgName="text_shape_linesize"
        containerStyle={titleContainerStyle}
        imageStyle={titleStyle} />
      <ToolIconRadioButtonSet style={{ width: '320px' }}>
        <SelectableNormalIconButton
          title="1"
          imagePath="images/setting-popup/line-size/btn_line_size_01"
          active={lineWidth === LineWidth.one}
          onClick={() => {
            ObjectDrawingUIAction.setLineWidth(selected, LineWidth.one, dispatch);
          }} />
        <SelectableNormalIconButton
          title="2"
          imagePath="images/setting-popup/line-size/btn_line_size_02"
          active={lineWidth === LineWidth.two}
          onClick={() => {
            ObjectDrawingUIAction.setLineWidth(selected, LineWidth.two, dispatch);
          }} />
        <SelectableNormalIconButton
          title="3"
          imagePath="images/setting-popup/line-size/btn_line_size_03"
          active={lineWidth === LineWidth.three}
          onClick={() => {
            ObjectDrawingUIAction.setLineWidth(selected, LineWidth.three, dispatch);
          }} />
        <SelectableNormalIconButton
          title="4"
          imagePath="images/setting-popup/line-size/btn_line_size_04"
          active={lineWidth === LineWidth.four}
          onClick={() => {
            ObjectDrawingUIAction.setLineWidth(selected, LineWidth.four, dispatch);
          }} />
        <SelectableNormalIconButton
          title="5"
          imagePath="images/setting-popup/line-size/btn_line_size_05"
          active={lineWidth === LineWidth.five}
          onClick={() => {
            ObjectDrawingUIAction.setLineWidth(selected, LineWidth.five, dispatch);
          }} />
      </ToolIconRadioButtonSet>
    </SettingTabPanelListRow>
  );
});

const mapStateToProps = (appStates: AppStates) => {
  const { selected, toolSettings } = appStates.ui.objectDrawing;
  return {
    selected,
    lineWidth: toolSettings[selected].lineWidth,
  };
};

export default connect(mapStateToProps)(ObjectLineWidthTabPanelListRow);
